
/**
 * videoId 유효성 검증 (11자, 허용 문자만)
 */
function isValidVideoId(videoId: string): boolean {
    return /^[A-Za-z0-9_-]{11}$/.test(videoId);
}

/**
 * 다양한 유튜브 URL 형식에서 videoId 추출
 *
 * 지원 형식:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - https://www.youtube.com/v/VIDEO_ID
 * - https://m.youtube.com/watch?v=VIDEO_ID
 * - VIDEO_ID (11자 직접 입력)
 */
function extractVideoId(input: string): string | null {
    const trimmed = input.trim();
    if (!trimmed) {
        return null;
    }

    // 11자 videoId 직접 입력 체크
    if (isValidVideoId(trimmed)) {
        return trimmed;
    }

    // URL 파싱
    try {
        const url = new URL(trimmed);

        // youtube.com/watch?v=... 형식
        if (url.hostname.includes('youtube.com')) {
            const videoId = url.searchParams.get('v');
            if (videoId && isValidVideoId(videoId)) {
                return videoId;
            }

            // /embed/VIDEO_ID 또는 /v/VIDEO_ID 형식
            const pathMatch = url.pathname.match(/^\/(embed|v)\/([A-Za-z0-9_-]{11})/);
            if (pathMatch) {
                return pathMatch[2];
            }
        }

        // youtu.be/VIDEO_ID 형식
        if (url.hostname === 'youtu.be') {
            const videoId = url.pathname.slice(1).split('?')[0];
            if (isValidVideoId(videoId)) {
                return videoId;
            }
        }
    } catch {
        // URL 파싱 실패 시 무시
    }

    return null;
}

/**
 * 유튜브 URL/videoId 유틸리티 함수
 */
const youtubeClientUtil = {
    isValidVideoId,
    extractVideoId,
};

export default youtubeClientUtil;
